import React, { useState } from "react";
import toast from "react-hot-toast";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from '@mui/material/Button';
import { LoadingButton } from "@mui/lab";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { apiCall } from "../../../utils/action";

function SanitizeTemplateDialog(props) {
  const { openDialog, handleCloseDialog, company_key } = props;
  const [loading, setLoading] = useState(false);
  const handleConfirm = async () => {
    setLoading(true);
    if (openDialog === "comment") {
      const params = { company_key: company_key, };
      apiCall(
        (response) => {
          setLoading(false);
          if (response.data.success) {
            toast.success(response.data.message);
            handleClose();
          } else toast.error(response.data.message);
        },
        params, "SANITIZE_COMMENTS"
      );
    } else {
      const params = { template_id: openDialog, company_key: company_key, };
      apiCall(
        (response) => {
          setLoading(false);
          if (response.data.success) {
            toast.success(response.data.message);
            handleClose();
          } else toast.error(response.data.message);
        },
        params, "SANITIZE_TEMPLATE"
      );
    }
  };

  const handleClose = () => {
    handleCloseDialog();
  };

  return (
    <Dialog open={openDialog !== null} onClose={() => handleClose()} style={{ overflow: "hidden" }}>
      <DialogTitle>
        <Grid container spacing={2} display={"flex"}>
          <Grid item xs={10} sm={11} display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Typography fontSize={18} fontWeight={500}>
              {`Sanitize ${openDialog === "comment" ? "Comments" : "Template"}`}
            </Typography>
          </Grid>
          <Grid item xs={1} display={"flex"} alignItems={"center"}>
            <IconButton onClick={() => handleClose()} className="closeButton">
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Typography fontSize={14}>{`This action cannot be undone. Do you want to continue?`}</Typography>
      </DialogContent>
      <DialogActions>
        <Grid container display={"flex"} gap={2} justifyContent={"center"} my={1}>
          <Button variant={"outlined"} onClick={() => handleClose()} sx={{ padding: "6px 28px 6px 28px" }}>
            Cancel
          </Button>
          <LoadingButton
            loading={loading}
            loadingPosition="start"
            variant={"contained"}
            onClick={() => handleConfirm()}
            sx={{
              padding: "6px 28px 6px 28px",
              "& .MuiLoadingButton-loadingIndicatorStart": { position: "relative", left: 0, marginRight: 1 },
            }}
          >
            Confirm
          </LoadingButton>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

export default SanitizeTemplateDialog;
